import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
	ReflectionService,
	ReflectionServiceCreateLogResponse,
} from '@services/member';
import { DomainService, LanguageService } from '@services/public';
import { skillUID } from 'jakapa-utilities-lite';
import { ReflectionData } from '../common';

const PAGE_PATH: string = 'skillBuilders.reflection.pages.summary';

@Component({
	selector: 'app-member-skill-builder-reflection-summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.scss'],
})
export class MemberSkillBuilderReflectionSummaryComponent implements OnInit {
	@Input() data: ReflectionData;

	// Page langauge.
	page: { [key: string]: string } = {
		title: '',
		newSummary: '',
		submit: '',
	};

	constructor(
		private _domainSvc: DomainService,
		private _languageSvc: LanguageService,
		private _reflectionSvc: ReflectionService,
		private _router: Router,
	) {}

	ngOnInit(): void {
		// Get page language.
		this._languageSvc
			.get([PAGE_PATH], {
				[PAGE_PATH]: {
					skills: this._toList(this.data.scores.map((score) => score.uid)),
					insight: this.data.insight,
					skill: this._domainSvc
						.getSkill(this.data.skillUID)
						.name.toLowerCase(),
					action: this.data.action.toLowerCase(),
				},
			})
			.then((value) => {
				if (typeof value[PAGE_PATH] === 'object' && value[PAGE_PATH] !== null)
					this.page = value[PAGE_PATH];
			});
	}

	submitOnClick(): void {
		this._reflectionSvc
			.createLog(this.data)
			.subscribe((res: ReflectionServiceCreateLogResponse) => {
				this._router.navigate(['member/dashboard/rewards']);
			});
	}

	private _toList(value: Array<string | skillUID>): string {
		// Copying array.
		value = [...value];

		// Convert skill UIDs to names.
		for (let i = 0; i < value.length; i++)
			if (typeof value[i] === 'number')
				value[i] = this._domainSvc.getSkill(<skillUID>value[i]).name;

		// Convert string array to a list.
		if (value.length === 0) return '';
		if (value.length === 1) return <string>value[0];
		if (value.length === 2) return value.join(' and ');
		return value
			.slice(0, -1)
			.concat(`and ${value.slice(-1)}`)
			.join(', ');
	}
}
